/**
 * Spalten des Exports (Anzeigename, interner Name) in der Reihenfolge der Datei und die fertigen Auswahlen.
 * Spiegelt `function/src/csv.ts` (exportColumns, EXPORT_PRESETS); die Function prüft die Namen und ist maßgeblich.
 */
export const EXPORT_COLUMNS: Array<[string, string]> = [
  ['Ablesung (Title)', 'Title'], ['OE', 'OE'], ['WIE', 'WIE'], ['Straße', 'Strasse'], ['Ort', 'Ort'], ['KC', 'KC'], ['Zweck', 'Zweck'], ['Energie', 'Energie'],
  ['Versorger', 'Versorger'], ['Marktlokationsnummer', 'Marktlokationsnummer'], ['Kundennummer', 'Kundennummer'], ['Zählernummer', 'Zaehlernummer'], ['Ort Zähler', 'OrtZaehler'],
  ['Hinweise', 'Hinweise'], ['Zählerstand', 'Zaehlerstand'], ['Zählerstand Vorjahr', 'ZaehlerstandVorjahr'], ['Bild', 'Bild'], ['Abgelesen von', 'AbgelesenVon'],
  ['Abgelesen am', 'AbgelesenAm'], ['Erforderliche Aktion', 'ErforderlicheAktion'], ['Aktion erledigt', 'AktionErledigt'], ['Importjahr', 'Importjahr'], ['ImportID', 'ImportID'],
  ['Ablesestatus', 'Ablesestatus'], ['OCR-Zählerstand', 'OCRZaehlerstand'], ['OCR-Konfidenz', 'OCRKonfidenz'], ['Plausibilitätsstatus', 'Plausibilitaetsstatus'],
  ['Bilddateiname', 'Bilddateiname'], ['OCR-Rohtext', 'OCRRohtext'], ['Letzte Fehlermeldung', 'LetzteFehlermeldung']
];

export type ExportScope = 'versorger' | 'vorlage' | 'alle' | 'auswahl';

const withoutTitle = EXPORT_COLUMNS.map(([, key]) => key).filter(key => key !== 'Title');
export const EXPORT_PRESETS: Record<Exclude<ExportScope, 'auswahl'>, string[]> = {
  versorger: withoutTitle.slice(0, 20),
  vorlage: withoutTitle,
  alle: EXPORT_COLUMNS.map(([, key]) => key)
};

export const EXPORT_SCOPES: Array<{ value: ExportScope; label: string; hint: (count: number) => string }> = [
  { value: 'versorger', label: 'Für den Versorger', hint: n => `${n} fachliche Spalten wie die SharePoint-Ansicht „Export“ (ohne Importjahr, ImportID, Ablesestatus und technische Spalten).` },
  { value: 'vorlage', label: 'Import-Vorlage', hint: n => `${n} Spalten der Import-Vorlage; die Datei lässt sich wieder importieren.` },
  { value: 'alle', label: 'Alle Spalten', hint: n => `Alle ${n} Spalten der Liste, auch Titel, OCR- und Plausibilitätsdaten.` },
  { value: 'auswahl', label: 'Eigene Auswahl', hint: () => 'Spalten selbst auswählen.' }
];
